import { render, staticRenderFns } from "./TermoCompromissoAssinaturaComponent.vue?vue&type=template&id=4684daec&scoped=true&lang=pug"
import script from "./TermoCompromissoAssinaturaComponent.vue?vue&type=script&lang=js"
export * from "./TermoCompromissoAssinaturaComponent.vue?vue&type=script&lang=js"
import style0 from "./TermoCompromissoAssinaturaComponent.vue?vue&type=style&index=0&id=4684daec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684daec",
  null
  
)

export default component.exports